import Map from '@/components/Map.vue'
import landingpage from '@/api/landingpage'
import { helpers } from '@/helpers'
export default {
  components: { Map },
  data () {
    return {
      isMenuToggle: false,
      isModalToggle: false,
      isLoggerToggle: false,
      showCover: false,
      // Contact form
      name: '',
      email: '',
      description: '',
      isSending: false,
      isCompleted: false,
      message: '',
      hash: '',
      vid: null
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted () {
    if (this.data && this.data.hash) {
      this.hash = this.data.hash
    }
    this.vid = document.querySelector('#videoLoop')
  },
  computed: {
    t () {
      if (this.data && this.data.template) {
        return this.data.template
      }
      return {}
    },
    d () {
      if (this.data && this.data.data) {
        return this.data.data
      }
      return {}
    },
    locationsVisited () {
      if (this.d && this.d.itineraries && this.d.itineraries.locations_visited_coo) {
        const locationsVisited = this.d.itineraries.locations_visited_coo
        return locationsVisited.filter(location => {
          return location.lat !== null || location.lng !== null
        })
      }
      return []
    },
    isLowerThanIE11 () {
      let detectIEregexp = ''
      if (navigator.userAgent.indexOf('MSIE') !== -1) {
        detectIEregexp = /MSIE (\d+\.\d+);/ // test for MSIE x.x
      } else {
        detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ // test for rv:x.x or rv x.x where Trident string exists
      }
      if (detectIEregexp.test(navigator.userAgent)) {
        let ieversion = Number(RegExp.$1)
        if (ieversion <= 11) {
          return true
        }
      }
      return false
    },
    firstOpporunityBackgroundImage () {
      return helpers.getBackgroundImageByIndex(this.d.consumer_section.images, 0)
    },
    secondOpporunityBackgroundImage () {
      return helpers.getBackgroundImageByIndex(this.d.consumer_section.images, 1)
    },
    thirdOpporunityBackgroundImage () {
      return helpers.getBackgroundImageByIndex(this.d.consumer_section.images, 2)
    }
  },
  methods: {
    getParsedImageUrl (url) {
      const encodedUrl = encodeURI(url)
      const withoutSingleQuote = encodedUrl.replace(/'/g, '%27')
      return withoutSingleQuote
    },
    toggleCover () {
      this.showCover = !this.showCover
    },
    toggleMenu () {
      this.isMenuToggle = !this.isMenuToggle
    },
    toggleModal () {
      this.isModalToggle = !this.isModalToggle
      document.body.classList.toggle('modal-open', this.isModalToggle)
    },
    toggleLogger () {
      this.isLoggerToggle = !this.isLoggerToggle
    },
    scrollTo (id) {
      this.$scrollTo(`#${id}`, { duration: 800, offset: -60 })
    },
    menuScrollTo (id) {
      this.toggleMenu()
      this.scrollTo(id)
    },
    dayScrollTo (index) {
      this.toggleModal()
      setTimeout(() => {
        const config = {
          container: '#modal-fullscreen',
          duration: 0,
          offset: -60,
          force: true,
          easing: [0.0, 0.0, 0.0, 0.0]
        }
        this.$scrollTo(`#day${index}`, config)
      }, 0)

      // this.scrollTo('day' + index)
    },
    sendContactForm () {
      const payload = {
        name: this.name,
        email: this.email,
        description: this.description,
        hash: this.hash,
        uuid: this.$route.params.uuid
      }
      this.isSending = true
      this.isCompleted = false
      this.message = ''
      landingpage.sendClientContact(payload)
        .then((response) => {
          this.hash = response.data.hash // Refreshing a new hash from the response
          this.message = response.data.message
          this.isSending = false
          this.isCompleted = true
          this.cleanContactForm()
        })
        .catch((error) => {
          this.message = error.response.data.message
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
        })
    },
    cleanContactForm () {
      this.name = ''
      this.email = ''
      this.description = ''
    },
    playVideo (play = true) {
      var vid = document.querySelector('#videoLoop')
      if (!vid) {
        return false
      }
      var firstPlay = document.querySelector('#firstPlayVideo')
      var firstSkipVideo = document.querySelector('#firstSkipVideo')
      firstPlay.classList.toggle('hidePlease')
      vid.play()
      vid.addEventListener('ended', () => {
        firstSkipVideo.classList.toggle('hidePlease')
        this.toggleVideo()
        setTimeout(() => {
          vid.muted = true
          if (play) {
            vid.loop = true
            vid.play()
          }
        }, 500)
      })
    },
    skipVideo () {
      var firstPlayVideo = document.querySelector('#firstPlayVideo')
      var firstSkipVideo = document.querySelector('#firstSkipVideo')
      firstPlayVideo.classList.add('hidePlease')
      firstSkipVideo.classList.add('hidePlease')
      this.vid.pause()
      this.toggleVideo()
    },
    toggleVideo () {
      const els = document.querySelectorAll('.hidePlease')
      els.forEach(e => {
        if (e.type === 'button') {
          return false
        }
        e.classList.toggle('hidePlease')
      })
    }
  }
}
